module.exports = __webpack_public_path__ + "img/img05.271f8a44.png";